import React, { Component } from 'react'

const ThemeContext = React.createContext()

class ThemeProvider extends Component {
  // Context state
  state = {
    theme: this.props.theme !== null ? this.props.theme : 'dark',
    topTheme: this.props.topTheme
  }

  setTheme = (theme) => {
    this.setState({ theme })
  }

  render() {
    const { children } = this.props

    return (
      <ThemeContext.Provider
        value={{
          theme: this.state.theme,
          setTheme: this.setTheme,
        }}
      >
        <div className={`${this.state.theme} ${this.state.topTheme ? `topbar--${this.state.topTheme}` : ''} page`}>
            { children }
        </div>
      </ThemeContext.Provider>
    )
  }
}

export default ThemeContext

export { ThemeProvider }